import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import { ResourcesService } from '../../../services/resources.service';
import { DatePipe } from '@angular/common';
import { isEmpty } from 'rxjs';
import { ModalComponent } from '../../shared/modal/modal.component';
import * as BlobUtil from 'blob-util';
import { SowService } from '../../../services/sow.service';
import { ManualTSService } from '../../../services/manualts.service';
import { ForecastService } from '../../../services/forecast.service';

@Component({
  selector: 'app-forecast',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule
],
  templateUrl: './forecast.component.html',
  styleUrls: ['./forecast.component.scss'],
    providers: [
      DatePipe
    ]
})
export class ForecastComponent implements OnInit {

  resource: any = {};
  listResourceSow: any = [];
  listEpic: any = [];
  listFeature: any = [];
  listTaskType: any = [];

  upload: any = {};

  constructor(
    private __ref: DynamicDialogRef,
    private __manualTSService : ManualTSService,
    private __datePipe: DatePipe,
    private __config: DynamicDialogConfig,
    private __dialogService : DialogService,
    private __forecastService : ForecastService
  ) {

  }

  ngOnInit(): void {
    this.getListResourceSow();
    this.getListEpic();
    this.getListTaskType();
    if (!this.isEmpty(this.__config.data.item)) {
      this.resource = this.__config.data.item;
      console.log(this.resource);
      this.getListTeamFeature();
    } else {
      this.resource.ID = 0;
    }
  }

  isEmpty(obj: any): boolean {
    return obj && typeof obj === 'object' && !Array.isArray(obj) && Object.keys(obj).length === 0;
  }

  getListResourceSow() {
    //this.__spinner.show({ type: 'loader' });
    this.listResourceSow = [];
    this.__manualTSService.getListResourceSow().subscribe((resp: any) => {
      this.listResourceSow = resp.listResources;
      //.__spinner.close();
    });
  }

  selectItem(event: any) {
    console.log(event);
    let item = this.listResourceSow.find((e: any) => e.RESOURCE_ID == event);
    this.resource.RESOURCE_ID = item.RESOURCE_ID;
    this.resource.USER = item.USERNAME;
    this.resource.USERID = item.ADO_USERID;
    this.resource.TEAM = item.TEAM;
  }

  getListEpic() {
    //this.__spinner.show({ type: 'loader' });
    this.listEpic = [];
    this.__manualTSService.getListEpic().subscribe((resp: any) => {
      this.listEpic = resp.listEpic;
      //this.__spinner.close();
    });
  }

  selectEpic(event: any) {
    this.resource.EPIC_ID = event;
    let item = this.listEpic.find((e: any) => e.WORKITEMID == event);
    this.resource.EPIC_TITLE = item?.TITLE;
    this.resource.ORGANIZATION = item?.CUSTOM_ORGANIZATION;
    this.getListTeamFeature();
  }

  getListTeamFeature() {
    //this.__spinner.show({ type: 'loader' });
    this.listFeature = [];
    this.__manualTSService.getListTeamFeature(this.resource.EPIC_ID).subscribe((resp: any) => {
      this.listFeature = resp.listData;
      //this.__spinner.close();
    });
  }

  selectFeature(event: any) {
    let item = this.listFeature.find((e: any) => e.WORKITEMID == event);
    this.resource.FEATURE_ID = item.WORKITEMID;
    this.resource.FEATURE_TITLE = item.TITLE;
  }

  getListTaskType() {
    //this.__spinner.show({ type: 'loader' });
    this.listTaskType = [];
    this.__manualTSService.getListTaskType().subscribe((resp: any) => {
      this.listTaskType = resp.listTaskTipeList;
      //this.__spinner.close();
    });
  }

  saveForecast() {
    //this.__spinner.show({ type: 'loader' });
    if (this.resource.RESOURCE_ID == undefined || this.resource.EPIC_ID == undefined || this.resource.TYPE == undefined ||
      this.resource.DATE == undefined || this.resource.EFFECTIVE_TIME == undefined || this.resource.MONTHLY_COST == undefined) {
        this.onShowMessage();
      return;
    }
    if (this.resource.RESOURCE_ID?.length == 0 || this.resource.EPIC_ID?.length == 0 || this.resource.TYPE?.length == 0 ||
      this.resource.DATE?.length == 0 || this.resource.EFFECTIVE_TIME?.length == 0 || this.resource.MONTHLY_COST?.length == 0) {
        this.onShowMessage();
      return;
    }
    this.__forecastService.saveForecast(this.resource).subscribe((resp: any) => {
      if(+resp?.an_resultado==0) {
        //this.__spinner.close();
        this.accept();
      }
    });
  }

  /**
   *
   * @param event
   * @returns
   */
  handleFileInput(event : any) {
    this.upload.fileName = event.target.files[0].name;
    this.upload.fileType = event.target.files[0].type;
    BlobUtil.blobToBase64String(event.target.files[0]).then((res) => {
      this.upload.fileUpload = res;
      this.resource.SOWDOC = this.upload.fileUpload;
    });
  }

  onShowMessage() {
    let confirm = this.__dialogService.open(ModalComponent, {
      width: '30%',
      header: 'Complete fields required',
      dismissableMask: false,
      closable: false,
    });

    confirm?.onClose.subscribe((resp: any) => {
    });
  }

  cancel() {
    let data = {
      accion: 'cancel'
    }
    this.__ref.close(data);
  }

  accept() {
    let data = {
      accion: 'success'
    }
    this.__ref.close(data);
  }

}
